export class BaseData {
    stops = [];
    list = [];
    group = [];
    static defaultKey = '0';

}